var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31311 16.6464L4.95956 17L5.31311 17.3536L13.8131 25.8536L14.1667 26.2071L14.5202 25.8536L29.6313 10.7424L29.9849 10.3889L29.6313 10.0353L26.798 7.202L26.4444 6.84845L26.0909 7.202L14.1667 19.1262L8.85355 13.8131L8.5 13.4596L8.14645 13.8131L5.31311 16.6464ZM33.5 17C33.5 26.1127 26.1127 33.5 17 33.5C7.88727 33.5 0.5 26.1127 0.5 17C0.5 7.88727 7.88727 0.5 17 0.5C26.1127 0.5 33.5 7.88727 33.5 17Z",
    fill: "#008000",
    stroke: "#008000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.73091160eecb7dd8a3e24bc0f2fc5f72.svg";
export { ForwardRef as ReactComponent };